<template>
	<div style="height: 100%;width: 100%;display:inline-block;">
	<!-- 卡片试图区域 -->
	<el-card>
		<div slot="header" class="clearfix">
		  <span>操作日志</span>
		</div>
	  <!-- 搜索与添加区域 -->
		<el-row :gutter="20">
			<el-col :span="8">
				<el-input 
				placeholder="请输入内容"
				v-model="queryInfo.query"
				clearable
				@clear="getLogList"
				:changeValue="changeValue"
				>
				    <el-button 
					slot="append" 
					icon="el-icon-search"
					@click="getLogList"
					></el-button>
				  </el-input>
				</el-col>
				<el-col :span="4">
					<el-button type="text" style="color: black;">筛选时间:</el-button>
				</el-col>
				<el-col :span="4" style="margin-left: -140px;">
					<el-date-picker
				      v-model="queryInfo.value2"
				      type="datetimerange"
				      :picker-options="pickerOptions"
				      range-separator="至"
				      start-placeholder="开始日期"
				      end-placeholder="结束日期"
				      align="right"
					  unlink-panels
				     :clearable="false"
					  >
				    </el-date-picker>
				</el-col>
		</el-row>
		<!-- 日志列表区域 -->
		 <el-table
		      :data="loglist"
			  border
			  stripe>
			  <el-table-column
			    type="index"
			   >
			  </el-table-column>
			  <el-table-column
			    prop="module"
			    label="操作类型"
			  				>
			  </el-table-column>
		      <el-table-column
		        prop="operation"
		        label="业务模块"
				>
		      </el-table-column>
			  <el-table-column
			     prop="operate_time"
			     label="操作时间"
				 width="140px"
				 >
				 <template slot-scope="scope">
					 {{scope.row.operate_time | fmtdate}}
				 </template>
			   </el-table-column>
			   <el-table-column
			     prop="username"
			     label="操作人员"
			   				>
			   </el-table-column>
			   <el-table-column
			     prop="operate_id"
			     label="操作的订单号"
			   		>
			   </el-table-column>
		   <el-table-column
		     prop="operate_params"
		     label="操作的内容"
			 width="500px"
		   		>
		   </el-table-column>
		    </el-table>
		<!-- 分页区域 -->
		<el-pagination
		      @size-change="handleSizeChange"
		      @current-change="handleCurrentChange"
		      :current-page="queryInfo.pagenum"
		      :page-sizes="[1, 2, 5, 10]"
		      :page-size="queryInfo.pagesize"
		      layout="total, sizes, prev, pager, next, jumper"
		      :total="total">
		    </el-pagination>
	</el-card>
		</div>
</template>

<script>
	export default{
		data(){
			return{
				 pickerOptions: {
				          shortcuts: [{
				            text: '最近一周',
				            onClick(picker) {
				              const end = new Date();
				              const start = new Date();
				              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
				              picker.$emit('pick', [start, end]);
				            }
				          }, {
				            text: '最近一个月',
				            onClick(picker) {
				              const end = new Date();
				              const start = new Date();
				              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
				              picker.$emit('pick', [start, end]);
				            }
				          }, {
				            text: '最近三个月',
				            onClick(picker) {
				              const end = new Date();
				              const start = new Date();
				              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
				              picker.$emit('pick', [start, end]);
				            }
				          }]
				        },
						//value2: '',
				//获取用户列表的参数对象
				queryInfo:{
					query:'',
					//默认选中日期，一整年
					value2:[new Date(new Date()- 3600 * 1000 * 24 * 365),new Date()],
					//当前的页数
					pagenum:1,
					//当前每页显示多少条数据
					pagesize:5
				},
				loglist:[],
				total:0,
			}
		},
		created(){
			this.getLogList()
		
		},
		computed:{
			//监听输入框是否有值，边打字边搜索
			changeValue(e){
				//点击后面几页，不显示数据、筛选指定跳到第一页。可以解决bug
				// console.log(e)
				if(this.queryInfo.query || this.queryInfo.value2){
					return this.queryInfo.pagenum = 1
					//this.getLogList()     
					}
				//this.getLogList()   
			},
		},
		methods:{
			
			async getLogList(){
				const {data:res} = await this.$http.getLogList({params:this.queryInfo})
				if (res.status !==0){
	             return this.$message.error('获取操作日志列表失败!')
				}
				this.loglist = res.data
				this.total = res.total
				console.log(this.loglist)
			},
			//监听pagesize改变的事件
			handleSizeChange(newSize){
				this.queryInfo.pagesize = newSize
				this.getLogList()
			},
			//监听页面值改变的事件
			handleCurrentChange(newPage){
				this.queryInfo.pagenum = newPage
				this.getLogList()
			},
		}
	}
</script>

<style lang="less" scoped>
</style>
